// 发布订阅系统
class Pubsub {
    constructor() {
        // 维护事件列表
        this.handles = {}
    }

    // 注册事件
    subscribe(type, handle) {
        if (!this.handles[type]) {
            this.handles[type] = []
        }
        this.handles[type].push(handle)
    }

    // 注销事件
    unsubscribe(type, handle) {
        let pos = this.handles[type].indexOf(handle)
        if (!handle) {
            // 不传handle, 则默认注销所有和type事件相关的事件处理函数.
            this.handles.length = 0
        } else {
            ~pos && this.handles[type].splice(pos, 1)
        }
    }

    // 通知事件
    publish() {
        // 执行所有和type事件相关的处理函数.
        let type = Array.prototype.shift.call(arguments)
        this.handles[type].forEach(handle => {
            // 箭头函数不绑定Arguments对象
            handle.apply(this, arguments)
        })
    }
}

const pubSub = new Pubsub;

export default pubSub;
